import { z } from "zod";
import { STREAM_PLATFORMS } from "../competition/streams";

/**
 * `GET /api/public/live-videos?games=sea|para` (user, 2026-11-03) — what the
 * portal home page polls (~1 KB) to show its player and live rail ONLY while
 * something is live. Unauthenticated, like the results feed, and DERIVED from
 * the same cached feed build in memory — no SQL of its own, so "is it live"
 * is the feed's own unit status (one rule, never re-decided here).
 *
 *   featured  the games' featured stream while it is switched on, else null
 *   live      units whose feed status is `live` AND have a video link —
 *             featured first, then `starts_at`, then `unit_id`
 *
 * Names are the feed's (English): `sport_code` is the portal's sport slug
 * (`sports[].code` in the feed), `event_name` the event's label, `unit_name`
 * the unit's label, `venue_name` the hall's name. `src` is the embed URL
 * (contracts `parseStreamUrl(...).embedSrc`) — the only thing to iframe.
 */
const platform = z.enum(STREAM_PLATFORMS);

export const liveVideosSchema = z
	.object({
		featured: z.object({ src: z.string().url(), platform, title: z.string().min(1) }).strict().nullable(),
		live: z.array(
			z
				.object({
					unit_id: z.string().min(1),
					event_id: z.string().min(1),
					sport_code: z.string().min(1),
					sport_name: z.string(),
					event_name: z.string(),
					unit_name: z.string(),
					venue_name: z.string().nullable(),
					/** ISO 8601, UTC — the scheduled start. */
					starts_at: z.string().nullable(),
					featured: z.boolean(),
					src: z.string().url(),
					platform,
				})
				.strict(),
		),
	})
	.strict();

export type LiveVideos = z.infer<typeof liveVideosSchema>;
export type LiveVideo = LiveVideos["live"][number];
